import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { PRODUCT_STATUS } from 'domains/scraper-product/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const ScraperProductStatusBadge = ({ status }) => {
  const colorMap = {
    [ PRODUCT_STATUS.ENABLED ]  : 'success',
    [ PRODUCT_STATUS.DISABLED ] : 'danger'
  }

  const color = colorMap[ status ] || 'secondary'
  const label = status || 'not productable'

  return <StatusBadge color={ color } label={ label } />
}

ScraperProductStatusBadge.propTypes = propTypes

export default ScraperProductStatusBadge
